// How many 45# plates show up on plate storage when "View With Gear" is clicked. 
export const HYBRID_LONG_PIN_PLATE_COUNT = 5

// SHARED_HYBRID_ITEMS' plate is authored resting on the bumper tray, so its origin sits this far below the plate's own centre - a pin needs it centred on the pin axis instead. Measured off the export.
export const HYBRID_PLATE_CENTER_RISE = 8.94

// The real thickness of that plate, so a stack spaces by the mesh it is actually built from rather than BARS' 2.15" HG 45.
export const HYBRID_PLATE_THICKNESS = 2.4

// Monster and Monster Lite are one product family sharing every cart, email and order surface.
export const HYBRID_RIG_SKUS: string[] = ['HYBRID-RIG-GROUP', 'ML-HYBRID-RIG-GROUP']
export const HYBRID_ADDON_BUNDLE_SKUS: readonly string[] = ['HYBRID-RIG-ADD-ON-BUNDLE', 'ML-HYBRID-RIG-ADD-ON-BUNDLE']
export const HYBRID_RACK_BUNDLE_SKUS: readonly string[] = ['HYBRID-RIG-BUNDLE', 'ML-HYBRID-RIG-BUNDLE']

// Exact bundle-option titles narrowed to Satin Black at 70" width, where no part spans in a colored finish.
export const HYBRID_FIXED_70_WIDTH_CROSSMEMBER_TITLES: readonly string[] = ['Rear Crossmember:', 'Front Crossmember:']

// Cart/order surfaces key off the bundle skus, never HYBRID_RIG_SKUS - a cart line is always one of the bundles, never the group.
export const HYBRID_BUNDLE_SKUS: readonly string[] = [...HYBRID_RACK_BUNDLE_SKUS, ...HYBRID_ADDON_BUNDLE_SKUS]

// What normalizeShelfName resolves the "(with Adjustable Dividers)" shelf to - Cave's own name for the same tray, shared so the builder and the PDP's shelf rules match on one string.
export const HYBRID_DIVIDER_SHELF = 'bumper'

// How many divider trays the rows below the top one may hold before the top row stops fitting.
export const HYBRID_TOP_SHELF_MAX_DIVIDERS_BELOW: Readonly<Record<string, number>> = {
  100 : 0,
  108 : 2,
}

// Lower-cased bundle-option titles, matched with includes() by isHybridRackLevelOption - the one predicate the PDP's rack/rig split and the cart's Rig 1 section both go through.
export const HYBRID_PLATE_STORAGE_OPTION_TITLE = 'plate storage'
export const HYBRID_RACK_LEVEL_OPTION_TITLES: readonly string[] = ['rack', HYBRID_PLATE_STORAGE_OPTION_TITLE]
export const REAR_CROSSMEMBER_OPTION_TITLE = 'rear crossmember'

// Every rig's Rig configurable repeats these attributes, but one shared rack means one shared value - so they are pinned to the rack's selection and hidden from the rig accordions. mass_width is deliberately absent: width is the one attribute a rig owns.
export const HYBRID_RACK_LEVEL_ATTRIBUTE_CODES: readonly string[] = ['rig_color', 'rack_height', 'rack_depth']
